import { memo, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import toast from "react-hot-toast";
import axios from "axios";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { offerFixedPriceSchema } from "../../app/schema";
import { useDispatch } from "react-redux";
import { showModal, hideConfirmModal } from "../../redux/counterSlice";
import { FormInputText } from "../../components/form-components/FormInputText";

const AddFlatPrice = ({
  open,
  handleClose,
  selectedRow: selectedFlatPriceRow,
  loadInitialData,
}) => {
  const dispatch = useDispatch();
  const isEditMode = selectedFlatPriceRow && selectedFlatPriceRow.id;

  const methods = useForm({
    resolver: yupResolver(offerFixedPriceSchema),
    defaultValues: {
      fixed_price: "",
    },
  });

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = methods;

  useEffect(() => {
    if (isEditMode && selectedFlatPriceRow) {
      reset({
        fixed_price: selectedFlatPriceRow?.fixed_price || "",
      });
    } else {
      reset({
        fixed_price: "",
      });
    }
  }, [selectedFlatPriceRow, isEditMode, reset]);

  const onSubmit = async (data) => {
    const payload = {
      fixed_price: data.fixed_price,
      active_status: isEditMode ? selectedFlatPriceRow.active_status ?? 1 : 1,
      ...(isEditMode && { id: selectedFlatPriceRow.id }),
    };

    try {
      const endpoint = isEditMode
        ? `/offerFixedPrice/${selectedFlatPriceRow.id}`
        : "/offerFixedPrice";
      const response = isEditMode
        ? await axios.put(endpoint, payload)
        : await axios.post(endpoint, payload);

      if (!response?.data?.error) {
        toast.success(response?.data?.message || "Saved successfully");
        loadInitialData();
        reset();
        handleClose();
      } else {
        let errDesc = response?.data?.message || "Something went wrong";
        if (response?.data?.data) {
          errDesc = Object.values(response.data.data).join("\n");
        }
        dispatch(showModal({ msg: errDesc, error: true }));
      }
    } catch (error) {
      dispatch(
        showModal({ msg: error?.message || "Server error", error: true })
      );
    } finally {
      dispatch(hideConfirmModal({ msg: "" }));
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle className="text-primary">
        {isEditMode ? "Edit Offer Fixed Price" : "Add Offer Fixed Price"}
      </DialogTitle>
      <DialogContent>
        <form id="add-offer-fixed-price-form" onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormInputText
                name="fixed_price"
                control={control}
                label="Fixed Price"
                errors={errors}
                mandatory="true"
                type="number"
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained" color="error">
          Cancel
        </Button>
        <Button
          type="submit"
          form="add-offer-fixed-price-form"
          color="primary"
          variant="contained"
          startIcon={<SaveIcon />}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default memo(AddFlatPrice);  